import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createNewCustomField: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.create-new-custom-field',
		defaultMessage: 'CREATE A NEW CUSTOM FIELD',
		description: 'Create a new custom field heading',
	},
	selectCustomFieldType: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.select-custom-field-type',
		defaultMessage: 'SELECT A CUSTOM FIELD TYPE',
		description: 'Select a custom field heading',
	},
	goBack: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.go-back',
		defaultMessage: 'Go back',
		description: 'Go back button arial label',
	},
});
